import CampusDevice from './CampusDevice';

export default CampusDevice;
